// src/layouts/scenarios/create/components/scenarioMap/layers/routesLayer.js

// 1. Accept either an array or an object with { items: [...] }
export const toRoutesArray = (routesInput) => {
  if (Array.isArray(routesInput)) return routesInput;
  if (routesInput && Array.isArray(routesInput.items)) return routesInput.items;
  return [];
};

// 2. Convert routes (+ links) to a FeatureCollection
export function routesToGeoJSON(routesInput, selectedRouteIds = []) {
  const routes = toRoutesArray(routesInput);
  const selectedSet = new Set(selectedRouteIds || []);
  const features = [];

  routes.forEach((route) => {
    const links = route.links || [];
    const routeId = route.id;
    const routeName = route.name || route.raw?.name || "";

    const isSelectedRoute = selectedSet.has(routeId);

    links.forEach((link) => {
      const geom = link.geometry;
      if (!geom || !geom.type || !geom.coordinates) return;

      const props = link.properties || {};

      features.push({
        type: "Feature",
        // we can use the link id as feature id if needed later
        id: link.id,
        geometry: geom,
        properties: {
          ...props,
          link_id: link.id,
          route_id: routeId,
          route_name: routeName,
          selected: isSelectedRoute,
          hoverMessage:
            props.hoverMessage ||
            `${routeName || "Route"} (link ${link.id})`,
        },
      });
    });
  });

  return {
    type: "FeatureCollection",
    features,
  };
}

// 3. Main entry: update only the source, not the layer
export function addOrUpdateRoutes(map, routesInput = [], selectedRouteIds = []) {
  if (!map) return;

  const geojson = routesToGeoJSON(routesInput, selectedRouteIds);
  const source = map.getSource("scenario-routes-source");

  if (source && source.setData) {
    source.setData(geojson);
  }
}
